import React from 'react'
import Helmet from 'react-helmet'

import Header from '../components/header'
import Footer from '../components/footer'
import '../scss/master.scss'

const Layout = ({ children, data }) => (
  <div>
    <Helmet>
      <title>Confetti for Adobe XD</title>
      <meta charset="utf-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="description" content="Easy to use plugin to generate gorgeous confetti patterns in 1 click in Adobe XD." />

      <link rel="apple-touch-icon" href="/assets/img/apple-touch-icon-76x76.png" />
      <link rel="apple-touch-icon" sizes="57x57" href="/assets/img/apple-touch-icon-57x57.png" />
      <link rel="apple-touch-icon" sizes="114x114" href="/assets/img/apple-touch-icon-114x114.png" />
      <link rel="apple-touch-icon" sizes="72x72" href="/assets/img/apple-touch-icon-72x72.png" />
      <link rel="apple-touch-icon" sizes="144x144" href="/assets/img/apple-touch-icon-144x144.png" />
      <link rel="apple-touch-icon" sizes="60x60" href="/assets/img/pple-touch-icon-60x60.png" />
      <link rel="apple-touch-icon" sizes="120x120" href="/assets/img/apple-touch-icon-120x120.png" />
      <link rel="apple-touch-icon" sizes="76x76" href="/assets/img/apple-touch-icon-76x76.png" />
      <link rel="apple-touch-icon" sizes="152x152" href="/assets/img/apple-touch-icon-152x152.png" />

      <link rel="icon" type="image/png" href="/assets/img/favicon-16x16.png" sizes="16x16" />
      <link rel="icon" type="image/png" href="/assets/img/favicon-32x32.png" sizes="32x32" />
      <link rel="icon" type="image/png" href="/assets/img/favicon-96x96.png" sizes="96x96" />
      <link rel="icon" type="image/png" href="/assets/img/favicon-128.png" sizes="128x128" />
      <link rel="icon" type="image/png" href="/assets/img/favicon-196x196.png" sizes="196x196" />

      <meta name="application-name" content="Confetti for Adobe XD" />
      <meta name="msapplication-TileColor" content="#FF007E" />
      <meta name="msapplication-TileImage" content="/assets/img/mstile-144x144.png" />
      <meta name="msapplication-square70x70logo" content="/assets/img/mstile-70x70.png" />
      <meta name="msapplication-square150x150logo" content="/assets/img/mstile-150x150.png" />
      <meta name="msapplication-wide310x150logo" content="/assets/img/mstile-310x150.png" />
      <meta name="msapplication-square310x310logo" content="/assets/img/mstile-310x310.png" />

      <meta name="theme-color" content="#FF007E" />

      <meta property="og:description" content="Easy to use plugin to generate gorgeous confetti patterns in 1 click in Adobe XD." />
      <meta property="og:image" content="/assets/img/meta-img.png" />
      <meta property="og:site_name" content="xdconfetti.com" />
      <meta property="og:title" content="Confetti for Adobe XD" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://xdconfetti.com" />

      <meta name="twitter:creator" content="@yummygum" />
      <meta name="twitter:site" content="@yummygum" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content="http://xdconfetti.com" />
      <meta name="twitter:title" content="Confetti for Adobe XD" />
      <meta name="twitter:description" content="Easy to use plugin to generate gorgeous confetti patterns in 1 click in Adobe XD." />
      <meta name="twitter:image" content="/assets/img/meta-img.png" />
      <meta name="twitter:site" content="@yummygum" />
      <meta name="twitter:domain" content="xdconfetti.com" />

      <meta itemprop="description" content="Easy to use plugin to generate gorgeous confetti patterns in 1 click in Adobe XD." />
      <link rel="icon" type="image/png" href="/assets/img/favicon-32x32.png" />
      <link href="https://fonts.googleapis.com/css?family=Encode+Sans:300,400,600,700,800,900" rel="stylesheet" />
    </Helmet>

    {children()}

    <Footer />
  </div>
)

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js